import {
  // City,
  CityOption,
  County,
  CountyOption,
  getCityOptions as getCityOptionsFunc,
  getCountyOptions as getCountyOptionsFunc,
  getZipcodeOptions as getZipcodeOptionsFunc,
  Locations,
  // Zipcode,
  ZipcodeOption
} from '@/helpers/locations';

let locationsPromise: Promise<Locations> | null = null;
let locations: Ref<Locations> | null = null;

export default function () {
  const { get } = useHttpMethods();

  const {
    public: { apiUrl }
  } = useRuntimeConfig();

  if (!locations) {
    locations = ref<Locations | null>(null);
  }

  if (!locationsPromise) {
    locationsPromise = get<Locations>(`${apiUrl}/locations`);

    locationsPromise.then(l => {
      locations.value = l;
      // Sort counties so Miami Dade, Broward, Palm Beach and Orange are first

      locations.value?.counties.sort((a, b) => {
        if (a.name === 'Miami-Dade') return -1;
        if (b.name === 'Miami-Dade') return 1;
        if (a.name === 'Broward') return -1;
        if (b.name === 'Broward') return 1;
        if (a.name === 'Palm Beach') return -1;
        if (b.name === 'Palm Beach') return 1;
        if (a.name === 'Orange') return -1;
        if (b.name === 'Orange') return 1;
        return 0;
      });
    });
  }

  function getCountyOptions(): CountyOption[] {
    return getCountyOptionsFunc(locations.value?.counties);
  }

  function getCityOptions(countyOption?: CountyOption): CityOption[] {
    return getCityOptionsFunc(
      countyOption ? [countyOption] : getCountyOptions()
    );
  }

  function getZipcodeOptions(
    cityOption?: CityOption,
    countyOption?: CountyOption
  ): ZipcodeOption[] {
    return getZipcodeOptionsFunc(
      cityOption ? [cityOption] : getCityOptions(countyOption)
    );
  }

  return {
    locationsPromise,
    locations,
    getCountyOptions,
    getCityOptions,
    getZipcodeOptions
  };
}
